export const namespace = 'canalplus.block.oneshop.propal.details';
export { default as Component } from './components/PropalDetails';
export { default as propsFormatter } from './propsFormatter';
